import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=2f121eb2&scoped=true&"
import script from "./Qrcode.vue?vue&type=script&lang=js&"
export * from "./Qrcode.vue?vue&type=script&lang=js&"
import style0 from "./Qrcode.vue?vue&type=style&index=0&id=2f121eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f121eb2",
  null
  
)

export default component.exports